import { useEffect } from 'react'

const useDocumentLang = (lang: string): void => {
  useEffect(() => {
    document.documentElement.setAttribute('lang', lang)
  }, [lang])
}

export default useDocumentLang
